export default __webpack_public_path__ + "static/media/fedex-priority.c3b34a9b.png";